import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import { DatePicker } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import OrderedItemsList from '../orderedItemsList/orderedItemsList';
import OrderProductField from '../orderProductField/orderProductField';
import http from '../../services/http';
import Loader from '../loader/loader';
import HourRange from '../hourRange/hourRange';
import device from '../../services/device';
import Payment from '../payment/payment';
import paymentActions from '../../actions/payment/payment';

import './createOrderForm.less';
import config from '../../config';

class CreateOrderForm extends React.Component {
  constructor(props) {
    super(props);

    const { address } = props;

    this.initialState = {
      values: {
        selectedDate: this.getMinDate(),
        selectedHour: null,
        'Address.Name': address.name || '',
        'Address.PhoneNumber': address.phoneNumber || '',
        'Address.Street': address.street || '',
        'Address.City': address.city || '',
        'Address.PostCode': address.postCode || '',
        'Address.NIP': address.nip || '',
        PaymentType: props.isBusinessUser
          ? config.paymentMethods.invoice
          : config.paymentMethods.online,
      },
      errors: {},
      loading: false,
      selectedProduct: null,
    };

    this.state = this.initialState;
  }

  onFieldChange = fieldName => e => {
    const { value } = e.target;

    this.setState(state => ({
      ...state,
      values: {
        ...state.values,
        [fieldName]: value,
      },
      errors: {
        ...state.errors,
        [fieldName]: null,
      },
    }));
  }

  onSwitchChange = fieldName => e => {
    const event = {
      target: {
        value: !!e.target.checked,
      },
    };
    this.onFieldChange(fieldName)(event);
  }

  mapValuesToSend = values => {
    const {
      'Address.Street': Street,
      'Address.City': City,
      'Address.PostCode': PostCode,
      'Address.Name': Name,
      'Address.NIP': NIP,
      'Address.PhoneNumber': PhoneNumber,
      selectedDate,
      selectedHour,
      Products,
      Note,
      PaymentType,
    } = values;

    const OrderDate = `${moment(selectedDate)
      .set('hour', selectedHour)
      .set('minute', 0)
      .set('second', 0)
      .format('DD-MM-YYYYTHH:mm:ss')}Z`;

    return {
      Address: {
        Name,
        Street,
        City,
        PostCode,
        NIP,
        PhoneNumber,
      },
      OrderDate,
      Products,
      Note,
      PaymentType: parseInt(PaymentType, 10),
    };
  }

  validateDateFields = () => {
    const { values } = this.state;
    const { selectedDate, selectedHour } = values;
    const errors = {};
    const city = values['Address.City'];
    const noAllowCity = ['sosnowiec', 'czeladz', 'czeladź', 'bedzin', 'będzin', 'mysłowice', 'myslowice', 'dabrowa gornicza', 'dąbrowa górnicza'];
    if (!selectedDate) {
      errors.selectedDate = 'Wybierz datę';
    }

    if (!selectedHour) {
      errors.selectedHour = 'Wybierz godzinę';
    }

    if (noAllowCity.map(m => m.toLowerCase()).includes(city.toLowerCase())) {
      errors.selectedCity = 'Niestety ale nie dostarczamy gazu do wybranej lokalizacji.';
    }

    // Sosnowiec czeladz Bedzin Myslowice Dabrowa Gornicza
    if (Object.keys(errors).length) {
      const error = new Error('Data validation error');
      error.errors = errors;

      throw error;
    }
  }

  onSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { values } = this.state;
    const { history } = this.props;

    const isOnlinePayment = values.PaymentType === config.paymentMethods.online;
    let paywallUrl = null;

    try {
      this.validateDateFields();

      const mappedValues = this.mapValuesToSend(values);

      const { avg, orderId } = await http.put('/api/client/createorder', mappedValues);

      if (isOnlinePayment) {
        paywallUrl = await paymentActions.createPaymentUrl(orderId);
      }

      this.setState({ loading: false });

      NotificationManager.success('Pomyślnie złożono zamówienie!', 'Sukces', 5000);

      // trigger notification on mobile devices
      device.postMessage({
        type: 'schedule-notification',
        date: moment(avg, 'DD-MM-YYYYTHH:mm:ssZ'),
      });

      if (isOnlinePayment) {
        window.location = paywallUrl;
        return;
      }
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      this.setState({ loading: false });

      const errorMessage = error.errorMessage || 'Nie udało się złożyć zamówienia!';
      NotificationManager.error(errorMessage, 'Błąd', 5000);

      const { errors } = error;

      if (errors) {
        this.setState({ errors });
      }

      return;
    }

    this.setState({ successfullySent: true });

    history.replace('/my-orders');
  }

  getFinalPrice = () => {
    const { values } = this.state;
    const { products } = this.props;

    if (!values.Products) {
      return null;
    }

    return values.Products.reduce((prev, product) => {
      const match = products.find(x => x.id === product.ProductId);

      if (!match) {
        return prev;
      }

      return prev + match.price * product.Quantity;
    }, 0);
  }

  setFormRef = form => {
    this.form = form;
  }

  addProduct = (productId, quantity) => {
    const { values } = this.state;
    const prevProducts = values.Products || [];

    // check if product already added, if so update quantity only
    const [match] = prevProducts.filter(x => x.ProductId === productId);

    let Products;

    if (match) {
      match.Quantity += quantity;
      Products = prevProducts.map(product => {
        if (product.ProductId === match.ProductId) {
          return match;
        }

        return product;
      });
    } else {
      Products = [
        ...prevProducts,
        {
          ProductId: productId,
          Quantity: quantity,
        },
      ];
    }

    const e = {
      target: {
        value: [...Products],
      },
    };

    this.onFieldChange('Products')(e);
  }

  deleteProduct = productId => {
    const { values } = this.state;
    const products = values.Products || [];
    const filteredProducts = products.filter(x => x.ProductId !== productId);

    this.setState(state => ({
      values: {
        ...state.values,
        Products: filteredProducts,
      },
    }));
  }

  getSelectedProducts = () => {
    const { values } = this.state;
    const { products } = this.props;

    return (values.Products || [])
      .map(({ ProductId, Quantity }) => {
        const [product] = products.filter(({ id }) => id === ProductId);

        return {
          ...product,
          quantity: Quantity,
        };
      });
  }

  selectDate = value => {
    const e = {
      target: {
        value,
      },
    };
    this.onFieldChange('selectedDate')(e);
  }

  selectPaymentType = e => {
    this.onFieldChange('PaymentType')(e);
  }

  selectHour = value => {
    const e = {
      target: {
        value,
      },
    };
    this.onFieldChange('selectedHour')(e);
  }

  getMinDate = () => {
    const endOfWorkingDay = moment().set({
      hour: 17, minute: 0, second: 0, millisecond: 0,
    });

    return moment().isBefore(endOfWorkingDay)
      ? moment().startOf('day')
      : moment().add(1, 'day').startOf('day');
  }

  shouldDisableDate = date => {
    const minDate = this.getMinDate();
    const maxDate = moment().add(3, 'day').endOf('day');

    return !moment(date).isBefore(maxDate)
    || !moment(date).isSameOrAfter(minDate);
  }

  renderErrorLabel = error => {
    if (!error) {
      return null;
    }

    return <div className="error-label">{error}</div>;
  }

  renderField = (fieldName, label, props = {}) => {
    const { errors } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const [error] = errors[fieldName] || [];

    return (
      <TextField
        onChange={this.onFieldChange(fieldName)}
        variant="outlined"
        label={label}
        error={!!error}
        helperText={error}
        fullWidth
        {...props}
      />
    );
  }

  render() {
    const {
      loading, values, errors,
    } = this.state;
    const { products, isBusinessUser } = this.props;
    const selectedProducts = this.getSelectedProducts();
    const hasProductsSelected = !!selectedProducts.length;

    return (
      <form ref={this.setFormRef} className="login-form-container" onSubmit={this.onSubmit} noValidate>
        {loading && <Loader />}

        <div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="create-order-section-header">
                <Typography variant="h6">Wybrane produkty</Typography>
              </div>
            </Grid>

            <Grid item xs={12} lg={4}>
              <OrderProductField
                products={products}
                addProduct={this.addProduct}
              />
            </Grid>
            <Grid item xs={12} lg={8}>
              {hasProductsSelected && (
              <OrderedItemsList
                products={selectedProducts}
                deleteProduct={this.deleteProduct}
              />
              )}
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="create-order-section-header">
                <Typography variant="h6">Czas dostawy</Typography>
              </div>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <div className="shipping-date-picker">
                <FormControl variant="outlined" fullWidth>
                  <DatePicker
                    value={values.selectedDate}
                    inputVariant="outlined"
                    disablePast
                    format="D MMMM (dddd)"
                    onChange={this.selectDate}
                    error={!!errors.selectedDate}
                    emptyLabel="Wybierz datę *"
                    required
                    shouldDisableDate={this.shouldDisableDate}
                    cancelLabel="Anuluj"
                  />
                  {this.renderErrorLabel(errors.selectedDate)}
                </FormControl>
              </div>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <HourRange
                onSelect={this.selectHour}
                error={!!errors.selectedHour}
                isToday={values.selectedDate.format('D') === moment().format('D')}
              />
              {this.renderErrorLabel(errors.selectedHour || errors.OrderDate)}
            </Grid>

          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="create-order-section-header">
                <Typography variant="h6">
                  Dane adresowe
                </Typography>
              </div>
            </Grid>

            <Grid item xs={12}>
              {this.renderField('Address.Name', 'Imię i nazwisko / Nazwa firmy', { required: true, value: values['Address.Name'] })}
            </Grid>

            <Grid item xs={12}>
              {this.renderField('Address.PhoneNumber', 'Numer telefonu', { required: true, value: values['Address.PhoneNumber'] })}
            </Grid>

            <Grid item xs={12} md={4}>
              {this.renderField('Address.Street', 'Adres', {
                required: true, variant: 'outlined', fullWidth: true, value: values['Address.Street'],
              })}
            </Grid>

            <Grid item xs={12} md={4}>
              {this.renderField('Address.City', 'Miasto', { required: true, fullWidth: true, value: values['Address.City'] })}
              {this.renderErrorLabel(errors.selectedCity)}
            </Grid>

            <Grid item xs={12} md={4}>
              {this.renderField('Address.PostCode', 'Kod pocztowy', { required: true, value: values['Address.PostCode'] })}
            </Grid>

            <Grid item xs={12}>
              {this.renderField('Address.NIP', 'NIP', { value: values['Address.NIP'] })}
            </Grid>

            <Grid item xs={12}>
              <div className="create-order-section-header">
                <Typography variant="h6">
                  Dodatkowe informacje
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              {this.renderField('Note', 'Notatka do zamówienia', { multiline: true })}
            </Grid>

            <Grid item xs={12}>
              {!isBusinessUser && (
                <Payment
                  onSelectedPaymentMethod={this.selectPaymentType}
                  selectedPaymentMethod={values.PaymentType}
                  finalPrice={this.getFinalPrice()}
                />
              )}
            </Grid>
          </Grid>

          <div className="send-button-container">
            <Button size="large" variant="contained" color="primary" type="submit" disabled={!hasProductsSelected}>
              Zamów
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

CreateOrderForm.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
    }),
  ).isRequired,
  address: PropTypes.shape({
    name: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    postCode: PropTypes.string,
    nip: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
  isBusinessUser: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isBusinessUser: state.auth.roles.indexOf('Company') !== -1,
});

export default withRouter(
  connect(mapStateToProps, null)(CreateOrderForm),
);
